import { DSNCNewsletter } from 'shared-definitions/types'
import { htmlMapper } from 'data-source/mappers/htmlMapper'
import { ApiComponentNewsletterProps } from 'data-source/types.wp'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { subscriptionMapper } from 'data-source/mappers/subscriptionMapper'
import { PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

export function ncNewsletter(
  input: ApiComponentNewsletterProps,
  opts: PLinkMapperOpts
): DSNCNewsletter {
  return {
    resource: 'nc-newsletter',
    done: {
      title: input.success.title,
      goHomeLabel: input.success.button_label,
      image: imageMapper(input.success.image, opts),
    },
    form: {
      title: input.title ?? input.subscribe.form.title,
      text: input.description ?? input.subscribe.form.text,
      emailLabel: input.subscribe.form.email,
      submitLabel: input.subscribe.form.submit,
      policyHtml: htmlMapper(input.subscribe.form.policy),
    },
    confirm: {
      title: input.subscribe.modal.title,
      textHtml: htmlMapper(input.subscribe.modal.text),
      defaultChoices: input.list_ids ? input.list_ids.map(item => item.toString()) : [],
      choices: input.subscribe.modal.choices.map(i => ({
        button: null,
        ...subscriptionMapper(i, opts),
      })),
    },
  }
}
